import { Component, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from 'src/app/core/auth/services/auth.service';
import { MoovingAssistantIA } from 'src/app/modules/assistant/models/assistant';
import { AssistantService } from 'src/app/modules/assistant/services/assistant.service';


@Component({
  standalone: false,
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit {

  user = inject(AuthService).$user;
  isVisible: boolean = false;
  moovingAssistant!: MoovingAssistantIA;
  assistantId!: string;
  messages: any[] = [];

  constructor(private router: Router, private assistantService: AssistantService) { }


  ngOnInit() {
    this.getAssistance();
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        const currentUrl = event.urlAfterRedirects;
        this.isVisible = !currentUrl.startsWith('/auth/select-organization');
      }
    });

  }

  getAssistance() {
    this.user.subscribe(user => {
      if (user) {
        this.assistantService.$currentAssistant
          .subscribe(moovingAssistant => {
            this.moovingAssistant = moovingAssistant!;
            this.assistantId = moovingAssistant!.idTelar;
            this.messages = [];
          });
      }
    })
  }

  getAssistanceByUserId(userId: string) {
    this.assistantService.getAssistantByUserId(userId)
      .subscribe(data => {
        this.moovingAssistant = data.records[0] as MoovingAssistantIA;
        this.assistantId = this.moovingAssistant.idTelar;
        this.messages = [];
      })
  }


}
